const VALORES_INCIDENCIA = ["NO Correcto", "✗", "✗ NO", "Tuerto", "Ciego", "Incorrecto", "Regular", "Malo"];

export const tieneIncidencia = (r) => {
  if (r.tipo === "Avería/Rotura") return true;
  const d = r.datos || {};
  if (d.criticos && Object.entries(d.criticos).some(([k, v]) => k !== "TODO CORRECTO" && v)) return true;
  if (d.uso && Object.entries(d.uso).some(([k, v]) => k !== "TODO CORRECTO" && v)) return true;
  if (d.items) {
    return Object.values(d.items).some(item => {
      const val = typeof item === "object" ? (item.v ?? item.value) : item;
      return VALORES_INCIDENCIA.includes(val);
    });
  }
  if (d.rows) return Object.values(d.rows).some(row => VALORES_INCIDENCIA.includes(row.value));
  return false;
};
